import React from 'react';
import clsx from 'clsx';

import './Icon.scss';

const Icon = ({
  icon,
  size,
  color,
  className,
  onClick,
  disableCommonStyles,
  currentColor,
  cursorPointer,
  disableCommonColors,
  style = [],
  ...rest
}) => {
  const SvgIcon = icon;

  return (
    <SvgIcon
      width={size}
      height={size}
      style={{ fill: color, ...style }}
      onClick={onClick}
      className={clsx(
        !disableCommonStyles && 'svg-icon',
        !disableCommonColors && 'svg-icon--color',
        currentColor && 'svg-icon--current-color',
        (onClick || cursorPointer) && 'svg-icon--pointer',
        className,
      )}
      {...rest}
    />
  );
};

export default Icon;
